import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const staffJwtReissueService = () => {
  return axiosInstance
    .post(ENDPOINTS.STAFF.AUTH.JWT_REISSUE)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
